
import Timer from '@/glxp/utils/timer'
import RAF from '@/js/utils/raf'
import easing from '../../glxp/utils/easing'
import WebglManager from "@/glxp/webglManager"
import DebugController from '@/glxp/debug/debugController'
import Load from '@/assets/images/soundRound.png'

import { vec3, mat4 } from "gl-matrix"

const _MAT4 = mat4.create()

export default {
    name: "progressCircle",
    data: () => {
        return {
            progress: 0,
            active: false,
            load: Load,
        }
    },

    mounted() {

        this.config = {
            offsetX: { value: -5, range: [-100, 100] },
            offsetY: { value: 25, range: [-100, 100] },
        }
        DebugController.addConfig(this.config, 'Progress-Circle')

        this.canvas = this.$refs["canvas"]
        this.ctx = this.$refs["canvas"].getContext("2d")
        RAF.suscribe("progressCircle", this.update.bind(this))
        // RAF.suscribe("bindHand", this.updateBind.bind(this))

        this.canvas.width = this.$el.offsetWidth * window.devicePixelRatio
        this.canvas.height = this.$el.offsetHeight * window.devicePixelRatio
        this.dpr = window.devicePixelRatio
        this.width = this.$el.offsetWidth * window.devicePixelRatio
        this.height = this.$el.offsetHeight * window.devicePixelRatio
        this.canvas.style.width = this.$el.offsetWidth * window.devicePixelRatio + "px"
        this.canvas.style.height = this.$el.offsetHeight * window.devicePixelRatio + "px"
        this.canvas.style.maxWidth = this.$el.offsetWidth + "px"
        this.canvas.style.maxHeight = this.$el.offsetHeight + "px"
        this.screenWidth = window.innerWidth
        this.screenHeight = window.innerHeight

        Timer.on("start", ()=>{
            this.progress = 0
            this.active = true
        })

        Timer.on("complete", () => {
            this.active = false
        })

        Timer.on("reset", () => {
            this.active = false
            this.progress = 0
        })

        Timer.on("progress", (p) => {
            this.progress = p
        })


    },

    beforeDestroy() {
        RAF.unsuscribe("progressCircle")
    },

    methods: {
        update(){
            if (!this.active) {
                return
            }

            const ctx = this.ctx
            const w = this.width
            const h = this.height

            ctx.clearRect(0, 0, w, h)

            // ctx.globalAlpha = .4
            // ctx.beginPath();
            // ctx.arc(w/2, h/2, w*.4, 0, 2 * Math.PI);
            // ctx.strokeStyle = "white" 
            // ctx.lineWidth = 3 * this.dpr
            // ctx.lineCap = "round"
            // ctx.stroke();

            

            // ctx.globalAlpha = 1
            // ctx.beginPath();
            // ctx.arc(w / 2, h / 2, w * .4, 0 - Math.PI / 2, 2 * easing.easeInOutQuart(this.progress) * Math.PI - Math.PI / 2);
            // ctx.strokeStyle = "white" 
            // ctx.lineWidth = 3 * this.dpr
            // ctx.lineCap = "round"
            // ctx.stroke();

            // ctx.globalAlpha = .4
            // ctx.drawImage(this.$refs.loadCircle, 0, 0, w, h);


            ctx.globalAlpha = 1
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(w / 2, h / 2);
            ctx.lineTo(w / 2, h / 2 - h * 0.6);
            ctx.arc(w / 2, h / 2, w * .6, 0 - Math.PI / 2 , 2 * easing.easeInOutQuart(this.progress) * Math.PI - Math.PI / 2);
            ctx.strokeStyle = "white" 
            ctx.lineWidth = 3 * this.dpr
            ctx.lineCap = "round"
            ctx.clip();
            ctx.drawImage(this.$refs.loadCircle, 0, 0, w, h);
            ctx.restore();
            // get hand position 
            
        },
        updateBind() {
            let scene = WebglManager.getScene("main")
            if (scene.handsRigs){
                if (scene.handsRigs[0]) {
                    let pos = vec3.fromValues(this.config.offsetX.value, this.config.offsetY.value, 0)
                    mat4.mul(_MAT4, scene.camera.getProjectionMatrix(), scene.camera.getViewMatrix())
                    mat4.mul(_MAT4, _MAT4, scene.handsRigs[0].rootNode.getMatrix())
                    // mat4.mul(_MAT4, _MAT4, scene.handsRigs[0].animator.tree.middleFinger[0].getMatrix())
                    vec3.transformMat4(pos, pos, _MAT4)
    
                    // this.$el.style.transform = `translate3D(${((pos[0] + 1) / 2) * this.screenWidth + 220}px, ${((-pos[1] + 1) / 2) * this.screenHeight}px, 0)`
                    this.$parent.posHandMe = `translate3D(${((pos[0] + 1) / 2) * this.screenWidth + this.screenWidth * 0.15}px, ${((-pos[1] + 1) / 2) * this.screenHeight + 50}px, 0)`
                }
    
                if (scene.handsRigs[1]) {
                    let pos = vec3.fromValues(this.config.offsetX.value, this.config.offsetY.value, 0)
                    mat4.mul(_MAT4, scene.camera.getProjectionMatrix(), scene.camera.getViewMatrix())
                    mat4.mul(_MAT4, _MAT4, scene.handsRigs[1].rootNode.getMatrix())
                    // mat4.mul(_MAT4, _MAT4, scene.handsRigs[0].animator.tree.middleFinger[0].getMatrix())
                    vec3.transformMat4(pos, pos, _MAT4)
    
                    this.$parent.posHandOpp = `translate3D(${((pos[0] + 1) / 2) * this.screenWidth - this.screenWidth * 0.2}px, ${((-pos[1] + 1) / 2) * this.screenHeight + 50}px, 0)`
                }
            }
            
        },
    }
}
